


























import Vue from 'vue';
import Component from 'vue-class-component';
import { Action, Mutation, Getter, State } from 'vuex-class';
import { Watch } from 'vue-property-decorator';

import AuthLoginPage from './components/Auth/Login.vue';
import Header from './components/UI/Header.vue';
import Menu from './components/UI/NewMenu.vue';
import { Access, Maybe } from './models';
import { IError } from './store';
// import { initMetrika } from './metrika';
import { getValue } from './utils';
import { TOKEN } from './const';

const Notifications = () => import('./components/UI/Notifications.vue');

@Component({
  components: { AuthLoginPage, Header, Menu, Notifications },
})
export default class App extends Vue {
  @Action('init') init: () => void;
  @Getter('modules', { namespace: 'user' }) modules: Record<string, string>;
  @State('token', { namespace: 'user' }) token: Maybe<string>;
  @Mutation('setToken', { namespace: 'user' }) setToken: any;
  @State('error') error: Maybe<IError>;
  transitionName = '';
  leftMenu = true;
  get hasPermission() {
    if (!this.$route.name) return undefined;
    const resource =
      /\w+?(?=(Detail|List|Tree|Create))/g.exec(this.$route.name)?.[0] || '';
    return this.modules[resource]?.includes(Access.Read) || undefined;
  }
  get hidePadding() {
    return (
      !this.$route.name?.includes('Detail') &&
      !this.$route.name?.includes('Create')
    );
  }
  created() {
    const token = getValue(TOKEN);
    if (token) this.setToken(token);
    this.init();
  }
  mounted() {
    const body = document.body;
    let timer: number;

    window.addEventListener(
      'scroll',
      () => {
        // @ts-ignore
        clearTimeout(timer);
        if (!body.classList.contains('disable-hover')) {
          body.classList.add('disable-hover');
        }

        timer = setTimeout(() => {
          body.classList.remove('disable-hover');
        }, 200);
      },
      false,
    );
    // initMetrika();
  }
  @Watch('$route')
  onRouteChange(to: any, from: any) {
    const toDepth = to.path.split('/').length;
    const fromDepth = from.path.split('/').length;
    switch (true) {
      case toDepth < fromDepth: {
        this.transitionName = 'slide-right';
        break;
      }
      case toDepth > fromDepth: {
        this.transitionName = 'slide-left';
        break;
      }
      case toDepth === fromDepth: {
        this.transitionName = 'crossfade';
        break;
      }
    }
  }
}
